module.exports = "https://static.zego.com/_next/static/images/Two-e5e5b4a0bf35a35ae072bbd726e7ec91.svg";